import React from 'react'
import { LineChart } from "react-chartkick";
import { toISODate, sortObject, isoDatesBetween } from "../helpers"

const TotalPomsChart = ({ poms }) => {
  let startDate = poms[0].start;
  let endDate = poms[0].stop;
  let idealPomsCount = {};
  let actualPomsCount = {};

  let total = 0;

  poms.forEach(pom => {
    startDate = Math.min(pom.start, startDate);
    endDate = Math.max(pom.stop, endDate);

    const date = toISODate(pom.stop);
    actualPomsCount[date] || (actualPomsCount[date] = total);

    actualPomsCount[date]++;
    total = actualPomsCount[date];
  });

  const idealPomsPerDay = 40 / 7;
  let i = 1;
  // Object.keys(actualPomsCount).forEach(date => {
  // console.log(isoDatesBetween(startDate, endDate), startDate, endDate)
  isoDatesBetween(startDate, endDate).forEach(date => {
    idealPomsCount[date] = idealPomsPerDay * i++;
  });

  actualPomsCount = sortObject(actualPomsCount);
  idealPomsCount = sortObject(idealPomsCount);

  const max = Math.max(total, idealPomsPerDay * i)

  return (
    <LineChart
      data={[
        { name: "ideal", data: idealPomsCount, color: "green" },
        { name: "actual", data: actualPomsCount, color: "blue" }
      ]}
      xtitle="Date"
      ytitle="Time"
      curve={false}
      download={"totalpoms"}
      title={"Total Poms"}
      max={max}
      min={0}
    />
  );
}

export default TotalPomsChart;


// WEBPACK FOOTER //
// ./src/charts/TotalPomsChart.js